module.exports = __webpack_public_path__ + "img/diploma.d1508123.jpg";